import { render } from "./SnackBar.vue?vue&type=template&id=6ab46800&scoped=true&ts=true"
import script from "./SnackBar.vue?vue&type=script&lang=ts"
export * from "./SnackBar.vue?vue&type=script&lang=ts"

import "./SnackBar.vue?vue&type=style&index=0&id=6ab46800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab46800"]])

export default __exports__